import { Component, Input } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SelectFormFieldComponent } from '../fields/select-form-field/select-form-field.component';
import { DatepickerFormFieldComponent } from '../fields/datepicker-form-field/datepicker-form-field.component';
import { TextareaFormFieldComponent } from '../fields/textarea-form-field/textarea-form-field.component';
import { StatusSelectFieldComponent } from '../fields/status-select-field/status-select-field.component';
import { CaseFormService } from 'app/case-form/case-form.service';
import { CaseStatusEnum } from 'app/shared/enums/case-status.enum';
import { UsersService } from 'app/shared/services/users.service';
import { IUser } from 'app/shared/models/users.model';
import { CaseFormModel } from 'app/case-form/case-form.model';
import { HelperService } from 'app/shared/services/helper.service';
import { Subject, takeUntil } from 'rxjs';
import { SelectFormEnum } from 'app/shared/enums/select-form.enum';

@Component({
  selector: 'app-activity-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SelectFormFieldComponent,
    StatusSelectFieldComponent,
    DatepickerFormFieldComponent,
    TextareaFormFieldComponent,
    TranslateModule
  ],
  templateUrl: './activity-form.component.html',
  styleUrl: './activity-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class ActivityFormComponent {
  @Input() caseStageItems: any[] = [];
  @Input() caseObject!: CaseFormModel;
  @Input() actionStatusItems: any[] = [];
  @Input() caseStatus!: string;
  @Input() currentCaseStage!: string;
  @Input() nextActionValidators!: boolean;
  private destroy$ = new Subject<void>();

  form: any;
  viewMode = true;
  caseStatusEnum = CaseStatusEnum;
  nextActionOwnerUsers: any[] = [];
  today: Date = new Date();

  constructor(
    public mainForm: FormGroupDirective,
    private caseFormService: CaseFormService,
    private usersService: UsersService,
    private helperService: HelperService
  ) { }

  ngOnChanges() {
    if (this.caseObject) {
      this.getUsersData();
    }
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('caseStage', new FormControl(null, []));
    this.form.addControl('nextActionStatus', new FormControl(null, []));
    this.form.addControl('nextActionOwnerId', new FormControl(null, []));
    this.form.addControl('nextActionDueDate', new FormControl(null, []));
    this.form.addControl('nextActionDescription', new FormControl(null, []));
  }

  onChangeCaseStage(data: any) {
    this.caseFormService.onChangeCaseStageEmiter.emit(data);

    if (data.statusValue) {
      this.form.get('caseStatus').setValue(data.statusValue);
    }

    if (
      (this.currentCaseStage === CaseStatusEnum.CLOSED_RESOLVED || this.currentCaseStage === CaseStatusEnum.CLOSED_NOT_RESOLVED)
      && data.value !== CaseStatusEnum.CLOSED_RESOLVED
      && data.value !== CaseStatusEnum.CLOSED_NOT_RESOLVED
    ) {
      this.form.get('caseStatus').setValue(CaseStatusEnum.NEW);
      this.form.get('nextActionStatus').setValue('InitialResponseRequired');
    }

    this.currentCaseStage = data.value;
  }

  changeNextActionStatus(data: any) {

    if (this.caseStatus === CaseStatusEnum.VERIFY) {
      return;
    }

    if (data.statusValue) {
      this.form.get('caseStatus').setValue(data.statusValue);

      if (this.form && this.form.get('caseStatus')?.value === CaseStatusEnum.VERIFY) {
        this.form.get('verifyDate').setValue(new Date());
      } else {
        this.form.get('verifyDate').setValue(null);
      }
    }

  }

  getUsersData() {
    this.usersService.users$.subscribe((users: IUser[]) => {
      this.nextActionOwnerUsers = this.helperService.getUsersListWithSelectedUser(users, this.caseObject.nextActionOwnerId, this.caseObject.nextActionOwner);
    });
  }

  searchUsers(event: string, term: string, usersList: string, page: number = 0, take: number = 50): void {
    this.usersService
      .getUsers(term, page * take, take)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: IUser[]) => {
        if (event === SelectFormEnum.SCROLL) {
          (this as any)[usersList] = [...(this as any)[usersList], ...res];
        } else if (event === SelectFormEnum.SEARCH) {
          (this as any)[usersList] = [...res];
        }
      });
  }

  getColorOfNextActionDueDate(nextActionDueDate: string): string {
    return this.helperService.getColorOfNextActionDueDate(nextActionDueDate);
  }
}
